import React from "react";
import OdooServices from "./OdooServices";
import HeroSection from "../common/HeroSection";
import ServiceSidebar from "../services/ServiceSidebar";
import {
  BookOpen,
  Briefcase,
  ChartNoAxesColumn,
  ChartPie,
  CircleCheckBig,
  Code,
  Database,
  Layers,
  PanelsTopLeft,
  PenTool,
  RefreshCw,
  Settings,
  ShoppingCart,
  Truck,
  Users,
  Zap,
} from "lucide-react";

export default function OdooErpDevelopment() {
  return (
    <div>
      <HeroSection
        title="Odoo ERP Development Services"
        breadcrumb={[
          { name: "Services", url: "/services" },
          { name: "Odoo Services", url: "/services/odoo-services" },
          {
            name: "Odoo ERP Development",
            url: "/services/odoo-services/erp-development",
          },
        ]}
        background="/assets/images/about/bg.png"
      />
      <div className="bg-white">
        <div className="py-16 px-4 mx-auto container">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 px-4">
          {/* Sidebar (OdooServices) */}
          <OdooServices />

          {/* <!-- Content Section --> */}

          <div className="lg:col-span-2">
            <div>
              <div className="relative rounded-xl overflow-hidden mb-8">
                <img
                  alt="Odoo ERP Development Services"
                  loading="lazy"
                  width="800"
                  height="450"
                  decoding="async"
                  data-nimg="1"
                  className="w-full h-auto object-cover rounded-xl"
                  src="/assets/images/odoo/erp-development.webp"
                />
              </div>
              <div className="mb-8">
                <span className="text-primary font-medium text-lg inline-block py-1 font-bold rounded-full bg-primary bg-opacity-10 mb-3">
                  End-to-End Business Solutions
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                  Odoo <span className="text-primary">ERP Development</span>{" "}
                  Services
                </h2>
                <div className="prose prose-lg max-w-none text-gray-600">
                  <p>
                    Transform your business operations with a comprehensive Odoo
                    ERP solution tailored to your specific industry and business
                    requirements. Our Odoo ERP development services help you
                    build an integrated business management system that connects
                    all aspects of your operations, from sales and inventory to
                    finance and human resources.
                  </p>
                  <p>
                    At{" "}
                    <span className="text-primary font-medium">
                      STISSA Technology LLP (TISSA Technology)
                    </span>
                    , we leverage the powerful capabilities of Odoo to create
                    end-to-end ERP solutions that streamline your business
                    processes, improve operational efficiency, and provide
                    real-time insights into your business performance. Our
                    experienced developers and consultants work closely with you
                    to understand your business needs and design an ERP system
                    that addresses your specific challenges.
                  </p>
                  <p>
                    Whether you're implementing ERP for the first time or
                    replacing legacy systems, our comprehensive approach ensures
                    a successful deployment that delivers tangible business
                    benefits and positions your organization for future growth.
                  </p>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Core ERP Modules We Implement
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Users className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Human Resources
                    </h4>
                    <p className="text-gray-600">
                      Comprehensive HR management, employee onboarding, time
                      tracking, leave management, performance evaluation, and
                      payroll integration.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <ShoppingCart className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Sales &amp; CRM
                    </h4>
                    <p className="text-gray-600">
                      Lead management, opportunity tracking, quotation creation,
                      order processing, and customer relationship management.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <ChartPie className="h-6 w-6 text-primary" />
                     
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Finance &amp; Accounting
                    </h4>
                    <p className="text-gray-600">
                      General ledger, accounts receivable/payable, asset
                      management, budgeting, financial reporting, and tax
                      compliance.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Database className="h-6 w-6 text-primary" />
                    
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Inventory Management
                    </h4>
                    <p className="text-gray-600">
                      Stock tracking, warehouse management, barcode scanning,
                      lot/serial tracking, and inventory valuation.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Truck className="h-6 w-6 text-primary" />
                  
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Manufacturing
                    </h4>
                    <p className="text-gray-600">
                      Bill of materials, routing, work orders, production
                      planning, quality control, and MRP (Material Requirements
                      Planning).
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                     <Briefcase className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Project Management
                    </h4>
                    <p className="text-gray-600">
                      Task scheduling, resource allocation, time tracking,
                      budgeting, and project profitability analysis.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Our ERP Development Services
                </h3>
                <div className="space-y-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      ERP Architecture Planning
                    </h4>
                    <p className="text-gray-600">
                      We design a comprehensive ERP architecture tailored to
                      your business needs, considering your current and future
                      requirements, integration points, and scalability
                      considerations.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      Core Module Configuration
                    </h4>
                    <p className="text-gray-600">
                      We configure Odoo's core modules to align with your
                      business processes, ensuring that the foundational
                      elements of your ERP system support your operations
                      effectively.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      Custom Module Development
                    </h4>
                    <p className="text-gray-600">
                      We develop custom modules to address specific business
                      requirements that aren't covered by standard
                      functionality, extending Odoo's capabilities to meet your
                      unique needs.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      Integration with External Systems
                    </h4>
                    <p className="text-gray-600">
                      We build seamless connections between Odoo and your
                      existing business systems, creating a unified data
                      ecosystem that eliminates silos and enables smooth
                      information flow.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      Data Migration &amp; Transformation
                    </h4>
                    <p className="text-gray-600">
                      We carefully migrate your data from legacy systems to
                      Odoo, ensuring data integrity and transforming it to fit
                      Odoo's structure for optimal performance.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      Business Process Optimization
                    </h4>
                    <p className="text-gray-600">
                      We analyze your current processes and implement optimized
                      workflows in Odoo, leveraging automation and best
                      practices to improve operational efficiency.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      Advanced Reporting &amp; Analytics
                    </h4>
                    <p className="text-gray-600">
                      We create custom reports and dashboards that provide
                      actionable insights into your business performance,
                      helping you make data-driven decisions.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      Performance Optimization
                    </h4>
                    <p className="text-gray-600">
                      We optimize your Odoo implementation for speed and
                      efficiency, ensuring that the system performs well even
                      with high user loads and large data volumes.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Benefits of Odoo ERP
                </h3>
                <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-primary">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Centralized data management across all business
                        functions
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Streamlined workflows that eliminate redundant processes
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Real-time visibility into business operations and
                        performance
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Automated business processes that reduce manual effort
                        and errors
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Enhanced collaboration between departments and teams
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Improved decision-making with integrated business
                        intelligence
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Scalable architecture that grows with your business
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Lower total cost of ownership compared to traditional
                        ERP systems
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Industry-Specific ERP Solutions
                </h3>
                <div className="space-y-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-3">
                      Manufacturing
                    </h4>
                    <p className="text-gray-600 mb-4">
                      Our manufacturing ERP solutions cover production planning,
                      shop floor control, quality management, and supply chain
                      integration, giving manufacturers complete visibility and
                      control over their operations.
                    </p>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          MRP &amp; Production Planning
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Quality Control Management
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Equipment Maintenance
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Cost Tracking &amp; Analysis
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-3">
                      Distribution &amp; Wholesale
                    </h4>
                    <p className="text-gray-600 mb-4">
                      For distributors and wholesalers, our ERP solutions
                      provide advanced inventory management, order processing,
                      warehouse operations, and logistics integration to
                      optimize the distribution chain.
                    </p>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Multi-warehouse Management
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Advanced Pricing Strategies
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Route Planning Optimization
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Batch &amp; Serial Number Tracking
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-3">
                      Professional Services
                    </h4>
                    <p className="text-gray-600 mb-4">
                      Our professional services ERP addresses the unique needs
                      of service-based businesses with project management,
                      resource allocation, time tracking, and service delivery
                      solutions.
                    </p>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Project Profitability Analysis
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Resource Allocation
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Time &amp; Expense Tracking
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Service Contract Management
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-3">Retail</h4>
                    <p className="text-gray-600 mb-4">
                      Retail businesses benefit from our integrated
                      point-of-sale, inventory management, customer loyalty, and
                      e-commerce solutions that create a unified retail
                      experience across channels.
                    </p>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          POS Integration
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Omnichannel Sales Management
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Customer Loyalty Programs
                        </span>
                      </div>
                      <div className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          Retail Analytics
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Success Story
                </h3>
                <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                  <h4 className="text-xl font-bold text-primary mb-4">
                    Food Manufacturing Company Transformation
                  </h4>
                  <p className="text-gray-600 mb-4">
                    A mid-sized food manufacturing company was struggling with
                    disconnected systems for production, inventory, sales, and
                    finance. They were managing critical business processes with
                    spreadsheets and multiple standalone applications, leading
                    to data inconsistencies, inefficient processes, and limited
                    visibility into their operations.
                  </p>
                  <p className="text-gray-600 mb-4">
                    We implemented a comprehensive Odoo ERP solution that
                    integrated all aspects of their business, from procurement
                    and production to sales and accounting. We configured
                    specialized modules for recipe management, quality control,
                    and batch tracking to address industry-specific
                    requirements. The system also included custom dashboards
                    that provided real-time insights into production efficiency,
                    inventory levels, and financial performance.
                  </p>
                  <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg text-center">
                      <div className="text-primary font-bold text-2xl">35%</div>
                      <div className="text-gray-600">
                        Reduction in Production Waste
                      </div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg text-center">
                      <div className="text-primary font-bold text-2xl">42%</div>
                      <div className="text-gray-600">
                        Improvement in Inventory Accuracy
                      </div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg text-center">
                      <div className="text-primary font-bold text-2xl">22%</div>
                      <div className="text-gray-600">
                        Increase in Overall Productivity
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Our ERP Implementation Process
                </h3>
                <div className="relative">
                  <div className="absolute left-6 top-0 bottom-0 w-1 bg-primary bg-opacity-20 ml-0.5"></div>
                  <div className="space-y-8">
                    <div className="relative pl-16">
                      <div className="absolute left-0 top-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center text-black font-bold">
                        1
                      </div>
                      <h4 className="text-xl font-bold text-gray-800 mb-2">
                        Discovery &amp; Analysis
                      </h4>
                      <p className="text-gray-600">
                        We analyze your business processes, identify pain
                        points, and define your ERP requirements in detail.
                      </p>
                    </div>
                    <div className="relative pl-16">
                      <div className="absolute left-0 top-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center text-black font-bold">
                        2
                      </div>
                      <h4 className="text-xl font-bold text-gray-800 mb-2">
                        Solution Design
                      </h4>
                      <p className="text-gray-600">
                        We design a comprehensive ERP solution that addresses
                        your specific needs and align with your business goals.
                      </p>
                    </div>
                    <div className="relative pl-16">
                      <div className="absolute left-0 top-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center text-black font-bold">
                        3
                      </div>
                      <h4 className="text-xl font-bold text-gray-800 mb-2">
                        Development &amp; Configuration
                      </h4>
                      <p className="text-gray-600">
                        We configure standard modules and develop custom
                        functionality to create a tailored ERP solution.
                      </p>
                    </div>
                    <div className="relative pl-16">
                      <div className="absolute left-0 top-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center text-black font-bold">
                        4
                      </div>
                      <h4 className="text-xl font-bold text-gray-800 mb-2">
                        Data Migration
                      </h4>
                      <p className="text-gray-600">
                        We migrate data from your existing systems to ensure a
                        smooth transition to the new ERP system.
                      </p>
                    </div>
                    <div className="relative pl-16">
                      <div className="absolute left-0 top-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center text-black font-bold">
                        5
                      </div>
                      <h4 className="text-xl font-bold text-gray-800 mb-2">
                        Testing &amp; Quality Assurance
                      </h4>
                      <p className="text-gray-600">
                        We conduct thorough testing to ensure all functionality
                        works correctly and meets your requirements.
                      </p>
                    </div>
                    <div className="relative pl-16">
                      <div className="absolute left-0 top-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center text-black font-bold">
                        6
                      </div>
                      <h4 className="text-xl font-bold text-gray-800 mb-2">
                        Training &amp; User Adoption
                      </h4>
                      <p className="text-gray-600">
                        We provide comprehensive training to ensure your team
                        can effectively use the new ERP system.
                      </p>
                    </div>
                    <div className="relative pl-16">
                      <div className="absolute left-0 top-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center text-black font-bold">
                        7
                      </div>
                      <h4 className="text-xl font-bold text-gray-800 mb-2">
                        Go-Live &amp; Support
                      </h4>
                      <p className="text-gray-600">
                        We manage the go-live process and provide ongoing
                        support to ensure a successful implementation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  What Our Clients Say
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft">
                    <div className="flex mb-4">
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                    </div>
                    <p className="text-gray-600 italic mb-4">
                      "Implementing Odoo ERP with STISSA Technology LLP (TISSA Technology) has
                      transformed how we operate. Our production planning is now
                      seamless, and we have real-time visibility into our
                      inventory and finances. The custom dashboards they
                      developed have become essential tools for our management
                      team."
                    </p>
                    <div>
                      <p className="font-bold text-gray-800">Michael Reynolds</p>
                      <p className="text-sm text-gray-500">
                        Operations Director, Global Manufacturing Solutions
                      </p>
                    </div>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft">
                    <div className="flex mb-4">
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                      <svg
                        className="w-5 h-5 text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                    </div>
                    <p className="text-gray-600 italic mb-4">
                      "The team at STISSA Technology LLP (TISSA Technology) went above and beyond to
                      understand our unique business processes. They didn't just
                      implement standard ERP modules; they tailored the entire
                      system to fit our specific needs. The result has been
                      improved efficiency and significant cost savings."
                    </p>
                    <div>
                      <p className="font-bold text-gray-800">Sarah Johnson</p>
                      <p className="text-sm text-gray-500">
                        CIO, Premier Distribution Co.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Our Technology Stack
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-white p-4 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-lg font-bold text-primary mb-2">Python</h4>
                    <p className="text-gray-600 text-sm">
                      Core programming language for Odoo development and
                      customization
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-lg font-bold text-primary mb-2">
                      PostgreSQL
                    </h4>
                    <p className="text-gray-600 text-sm">
                      Robust database system for reliable data storage and
                      management
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-lg font-bold text-primary mb-2">XML</h4>
                    <p className="text-gray-600 text-sm">
                      For defining views and data structures in Odoo
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-lg font-bold text-primary mb-2">
                      JavaScript
                    </h4>
                    <p className="text-gray-600 text-sm">
                      For enhancing user interface and client-side functionality
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-lg font-bold text-primary mb-2">
                      OWL Framework
                    </h4>
                    <p className="text-gray-600 text-sm">
                      Odoo's Web Library for building dynamic web components
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-lg font-bold text-primary mb-2">
                      RESTful APIs
                    </h4>
                    <p className="text-gray-600 text-sm">
                      For seamless integration with external systems and
                      applications
                    </p>
                  </div>
                </div>
              </div>
           
            </div>
          </div>
        </div>
      </div>
      </div>
      
    </div>
  );
}
